




























































































































































import { Post, Cid, User, Id, WallReactionData, PostConnection } from 'types'
import { Mixins, Component, Prop } from 'vue-property-decorator'
import { Getter, State, namespace } from 'vuex-class'

import { postColorTailwindClass } from 'bits/post_color'
import { observeIntersection } from 'bits/intersection'
import { isUrl } from 'bits/url'

import SurfacePostAuthor from 'vuecomponents/surface_post_author.vue'
import SurfacePostWords from 'vuecomponents/surface_post_words.vue'
import SurfacePostAttachment from 'vuecomponents/surface_post_attachment_new.vue'
import SurfacePostModeration from 'vuecomponents/surface_post_moderation.vue'
import SurfacePostReactionNew from 'vuecomponents/surface-post-reaction-new.vue'
import SurfacePostComments from 'vuecomponents/surface_post_comments.vue'
import SurfacePostCommentsIcon from 'vuecomponents/surface_post_comments_icon.vue'
import SurfacePostActions from 'vuecomponents/surface_post_actions.vue'

import { IntlMixin } from 'vuemixins/intl_mixin'
import { Reaction } from '@padlet/arvo'
import { BeethovenDisplayAttributes } from '@padlet/beethoven-client'
import { BeethovenLuminance } from '@padlet/beethoven-client/lib/types'

@Component({
  components: {
    SurfacePostAuthor,
    SurfacePostWords,
    SurfacePostAttachment,
    SurfacePostModeration,
    SurfacePostReactionNew,
    SurfacePostComments,
    SurfacePostCommentsIcon,
    SurfacePostActions,
  },
})
export default class SurfacePostBeingShowedNew extends Mixins(IntlMixin) {
  $el!: HTMLDivElement
  @Prop() index!: number
  @Prop() post!: Post
  @Prop() edit!: boolean
  @Prop() isLast!: boolean
  @Prop() fitHeightToContainer!: boolean
  @Prop() verticallyCenterContent!: boolean

  // **** GENERAL SHOW ATTRIBUTES ****
  @Getter colorScheme!: 'light' | 'dark'
  hasIntersectedViewport = false
  @Getter xAuthor!: boolean
  @Getter xPostCommentsInPanel!: boolean
  @Getter isStream!: boolean

  get isPadletColorSchemeDark(): boolean {
    return this.colorScheme === 'dark'
  }

  get postColorClass(): string {
    return postColorTailwindClass({ postColor: this.post.color, isLightColorScheme: this.colorScheme == 'light' })
  }

  @(namespace('postConnection').State) postToConnectFromId!: Id
  @(namespace('postConnection').Getter) connections!: PostConnection[]

  areConnected(post1Id, post2Id) {
    return (
      this.connections.filter((c) => {
        return (
          (c.from_wish_id === post1Id && c.to_wish_id === post2Id) ||
          (c.from_wish_id === post2Id && c.to_wish_id === post1Id)
        )
      }).length > 0
    )
  }

  get xConnect(): boolean {
    return (
      !!this.postToConnectFromId &&
      this.postToConnectFromId !== this.post.id &&
      !this.areConnected(this.post.id, this.postToConnectFromId)
    )
  }

  get xWords() {
    return !!this.post.subject || !!this.post.body
  }

  /**
   * Only for timeline: the whole post can be scrolled.
   */
  get isWishContentScrollable() {
    return this.isTimeline || this.isMap
  }

  get isAttachmentOnTop() {
    return this.isTimeline || this.isMap
  }

  get xModeration(): boolean {
    return !this.post.published
  }

  /**
   * Only load attachment when there is one and when post is in viewport
   */
  get xAttachment(): boolean {
    const attachment = this.post.attachment
    const hasAttachment = !!attachment && isUrl(attachment)
    return hasAttachment && this.hasIntersectedViewport
  }

  // STALKER BAR
  @Getter isMap!: boolean
  @Getter isTimeline!: boolean

  get xStalkerBar(): boolean {
    return this.xComments || this.xReactions
  }

  // REACTIONS

  @Getter isReactable!: boolean
  @Getter reactionData!: WallReactionData
  @(namespace('reaction').State) postIdBeingReactedTo!: Id
  @(namespace('reaction').Getter('reactionIdsByPost')) wallReactionIdsByPost!: { [wishId: number]: string[] }

  get postReactionIds(): string[] {
    if (!this.post.id) return []
    return this.wallReactionIdsByPost[this.post.id] || []
  }

  get xReactions(): boolean {
    // when a user is viewing a wall with reaction disabled and then reaction is enabled + someone react to something
    // the realtime message for new reaction may come before the reaction enable message
    // => wait for reactionData to be available before showing reactions
    return (this.isReactable || this.postReactionIds.length > 0) && !!this.reactionData
  }

  get isBeingReacted() {
    return this.postIdBeingReactedTo === this.post.id
  }

  // COMMENTS

  @Getter isCommentable!: boolean
  @Getter isBackchannel!: boolean
  @(namespace('comment').State) commentBeingEditedId!: Id
  @(namespace('comment').Getter('commentIdsByPost')) wallCommentIdsByPost!: { [wishId: number]: string[] }
  @(namespace('comment').State('commentEntities')) wallComments!: Comment[]

  get postCommentIds(): string[] {
    if (!this.post.id) return []
    return this.wallCommentIdsByPost[this.post.id] || []
  }

  get xComments(): boolean {
    // Turn comments off when switching to Backchannel
    return this.post.published === true && (this.isCommentable || this.postCommentIds.length > 0) && !this.isBackchannel
  }

  // ACTIONS ATTACHMENT

  @(namespace('attachment').Getter) linkDisplayAttributesForUrl!: (attachment: string) => BeethovenDisplayAttributes

  get attachmentAttributes(): BeethovenDisplayAttributes | null {
    if (!this.post.attachment) return null
    return this.linkDisplayAttributesForUrl(this.post.attachment)
  }

  get attachmentLuminance(): BeethovenLuminance | null {
    return (this.attachmentAttributes && this.attachmentAttributes.image_luminance) || null
  }

  // **** PERMISSION-RELATED SHOW ATTRIBUTES ****

  @State user!: User
  @Getter canIModerate!: boolean
  @Getter canIWrite!: boolean

  get wasWrittenByCurrentUser() {
    return !!this.user.id && this.post.author_id === this.user.id
  }
  get isEditableByCurrentUser() {
    return this.canIModerate || (this.wasWrittenByCurrentUser && this.canIWrite)
  }

  // **** INTERACTIONS ****

  // Post
  @(namespace('postAction').Action) showPostActionMenu!: (payload: { postCid: Cid }) => void
  @(namespace('post').Action) startEditingPost!: (payload: { postCid: Cid }) => void
  @(namespace('post').Action) deletePost!: (payload: { postCid: Cid }) => void
  @(namespace('post').Action) approvePost!: (payload: { postCid: Cid }) => void

  @State isMobile!: boolean

  tryShowActions(e: MouseEvent) {
    if (
      this.isMobile ||
      this.xConnect ||
      ['a', 'textarea', 'input', 'select', 'option'].includes((e.target as Element).tagName?.toLowerCase()) ||
      e.shiftKey
    ) {
      return
    }
    e.preventDefault()
    this.showPostActionMenu({ postCid: this.post.cid })
  }

  confirmDelete() {
    if (
      !this.post.id /* post is new */ ||
      (!this.post.body && !this.post.subject && !this.post.attachment) ||
      confirm(this.__('Are you sure you want to delete this post? This cannot be undone!'))
    ) {
      this.deletePost({ postCid: this.post.cid })
    }
  }

  //Comment
  @(namespace('comment').Action) createComment!: (...args: any[]) => void
  @(namespace('comment').Action) editComment!: (...args: any[]) => void
  @(namespace('comment').Action) stopEditingComment!: (...args: any[]) => void
  @(namespace('comment').Action) startEditingComment!: (...args: any[]) => void
  @(namespace('comment').Action) showCommentActionMenu!: (...args: any[]) => void

  // **** LIFECYCLE ****
  mounted() {
    if (!this.hasIntersectedViewport) {
      observeIntersection(this.$el, () => {
        this.hasIntersectedViewport = true
      })
    }
  }
}
